import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '治愈漫画', path: '/category/healing' },
      { label: '热血漫画', path: '/category/action' },
      { label: '恋爱漫画', path: '/category/romance' },
      { label: '悬疑漫画', path: '/category/mystery' },
    ],
  },
  {
    title: '热门推荐',
    links: [
      { label: '洞洞杂货铺', path: '/comic/dongdong-zahuopu' },
      { label: '剑圣传说', path: '/comic/jiansheng-chuanshuo' },
      { label: '星空王子', path: '/comic/xingkong-wangzi' },
      { label: '勇者团', path: '/comic/yongzhe-tuan' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌故事', path: '/about' },
      { label: '商务合作', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '用户协议', path: '/about' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '阅读指南', path: '/about' },
      { label: '常见问题', path: '/about' },
      { label: '投诉建议', path: '/about' },
      { label: '版权声明', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-14">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4 whitespace-nowrap">
                {group.title}
              </h3>
              <div className="w-8 h-px bg-background-300 mb-4" />
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6 pt-10 border-t border-background-200/60">
          <div className="flex items-baseline gap-1">
            <span className="font-heading text-5xl md:text-6xl font-black text-foreground-200 leading-none">
              178
            </span>
            <span className="font-heading text-5xl md:text-6xl font-black text-foreground-200 leading-none">
              漫画
            </span>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 md:gap-6">
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors duration-200 cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-links-line text-lg" />
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors duration-200 cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-lg" />
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors duration-200 cursor-pointer"
                aria-label="QQ"
                rel="nofollow"
              >
                <i className="ri-qq-line text-lg" />
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors duration-200 cursor-pointer"
                aria-label="B站"
                rel="nofollow"
              >
                <i className="ri-movie-line text-lg" />
              </a>
            </div>
            <p className="text-xs text-foreground-500 whitespace-nowrap">
              &copy; 2026 178漫画网 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}